import { Grid, GridRow, GridItem } from './../Grid';
import { DictionaryItem } from '../../types/Dictionary';
import { MediaLibraryItemComponent } from '../MediaLibrary/MediaLibraryItemComponent';
import { useRouter } from 'next/router';
import { CorporateButton } from './../CorporateButton';
import { Text, Title } from './../Typography';
import { Items } from './styles';

interface IProps {
  data: any;
  copy: DictionaryItem[]
}

export function CorpMediaDownloadPreview(props: IProps) {
  const router = useRouter();
  const { data, copy } = props;
  const onItemClick = (e: Event, itemId: string) => {
    e.preventDefault();
  }

  // for some reason graphcms is returning an object rather than an array here
  const keys = Object.keys(data?.downloads);
  return (
    <div>
      <Grid>
        <GridRow columns={16} tabletBreakpoint>
          <GridItem colStart={2} colSpan={14}>
            <div className="text-center">
              <Text className='mb-4' type="lead" tag="p">{data?.super}</Text>
              <Title className='mb-15' type="md" tag="p">{data?.title}</Title>
            </div>
          </GridItem>
        </GridRow>
        <Items columns={16} tabletBreakpoint>
          {keys.map((key: any) => {
            const item = data?.downloads?.[key];
            return <GridItem key={item.id} colSpan={4}>
              <MediaLibraryItemComponent thumbnailCursor={false} showPreviewButton={false} copy={copy} item={item} onItemClick={onItemClick} pathname={router.pathname} />
            </GridItem>
          })}
        </Items>
      </Grid>
      <div className='md:mt-15 flex justify-center'>
        <a href={data?.link?.url} target="_self">
          <CorporateButton
            type="button"
            color="primaryalternative"
            label={data?.link?.displayName}
            buttonType="button"
          />
        </a>
      </div>
    </div >
  );
}
